import { Avatar } from "primereact/avatar";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useTranslation } from "react-i18next";
import { retrieveMarketSummary } from "../../../Services/MarketSummaryApiService";
import { useNavigate } from "react-router-dom";
import IndexSummary from "./indexSummary";
import DateTime from "../datetime";
import { Tooltip } from "primereact/tooltip";
import DividendDialog from "../Dividend/dialog"
import { useAuthHeader } from "../../../auth/AuthService";
import data from "../../../Assets/stock-special-dividend.json";
import { Dialog } from "primereact/dialog";

export default function RealTimeQuotation ({STATE}) {
    const navigate = useNavigate();
    const {t, i18n} = useTranslation();
    const [cookies, setCookie] = useCookies(['bType', 'icode', 'mksSort']);
    const [trdSum, setTrdSum] = useState({});
    const [mType, setMType] = useState(cookies.bType == 'G' ? '2' : '1');
    const [issues, setIssues] = useState([]);
    const authHeader = useAuthHeader();
    const [loading, setLoading] = useState(false);
    const [sort, setSort] = useState(cookies.mksSort ? cookies.mksSort : "esymbol");
    const sortFields = [
        {name: "IPO", value:"created"},
        {name: "Stock Symbol", value:"esymbol"}
    ]

    const previewStock = (icode) => {
        setCookie('icode', icode);
        navigate('/current-stock');
    }

    const stockBodyTemplate = (rowData) => {
      let sd = undefined;
      let description = "";
      Object.keys(data).map((icode, i) => {
        if (icode === rowData?.icode) {
          sd = data[icode]?.link;
          description = data[icode]?.description;
        }
      });
  
      return (
        <div className="flex align-items-center relative cursor-pointer">
          <Avatar
            image={`/img/issue_logo_icons/${rowData?.icode}_logo.jpg`}
            shape="circle"
            onClick={() => previewStock(rowData?.icode)}
          />
          <span className="font-bold ml-2">
            <span onClick={() => previewStock(rowData?.icode)}>
              {rowData?.stock?.toLocaleString("en-US")}
            </span>
            &nbsp;
            {sd && <SdDialog link={sd} description={description}></SdDialog>}
            &nbsp;
            {rowData?.lp != 0 && (
              <img src="/img/LP-Logo.png" className="vertical-align-super"></img>
            )}
            <DividendDialog issue={rowData}></DividendDialog>
          </span>
        </div>
      );
    };

    const bidBodyTemplate = (rowData) =>  {
        return (
            <div className="flex-row">
                <span className={(rowData.bid == rowData.basePrice || rowData.bid == 0 ? "text-white" : (rowData.bid < rowData.basePrice ? "text-red" : "text-green")) + " flex justify-content-center font-bold mb-1"}>{rowData?.bid?.toLocaleString('en-US')}</span>
                <span className="flex justify-content-center text-sm">{rowData?.bidVol?.toLocaleString('en-US')}</span>
            </div>
        );
    }

    const askBodyTemplate = (rowData) =>  {
        return (
            <div className="flex-row">
                <span className={(rowData.ask == rowData.basePrice || rowData.ask == 0 ? "text-white" : (rowData.ask < rowData.basePrice ? "text-red" : "text-green")) + " flex justify-content-center font-bold mb-1"}>{rowData?.ask?.toLocaleString('en-US')}</span>
                <span className="flex justify-content-center text-sm">{rowData?.askVol?.toLocaleString('en-US')}</span>
            </div>
        );
    }

    const lastBodyTemplate = (rowData) =>  {
        return (
            <div className="flex-row">
                <span className={(rowData.last == rowData.basePrice ? "text-white" : (rowData.last < rowData.basePrice ? "text-red" : "text-green")) + " flex justify-content-center font-bold mb-1"}>{rowData?.last?.toLocaleString('en-US')}</span>
                <span className={(rowData?.change == 0 ? "text-white" : (rowData?.change > 0 ? "text-green" : "text-red"))  + " flex justify-content-center text-sm"}>
                    <ChangeSign
                        change={rowData.change}
                        vol_qty={rowData.volume}
                        base_price={rowData.basePrice}
                        last_price={rowData.last}
                        lower_price={rowData.lower}
                        upper_price={rowData.higher}
                    ></ChangeSign>
                    {Math.abs(rowData?.change)}
                </span>
                
            </div>
        );
    }

    const tradingBodyTemplate = (rowData) =>  {
        return (
            <div className="flex-row align-items-center pr-2">
                <span className='flex justify-content-end mb-1 font-bold'>{rowData?.volume?.toLocaleString('en-US')}</span>
                <span className="flex justify-content-end text-sm">{rowData?.value?.toLocaleString('en-US')}</span>
            </div>
        );
    }

    const highLowBodyTemplate = (rowData) =>  {
        return (
            <div className="flex-row">
                <span className={(rowData.high == rowData.basePrice || rowData.high == 0 ? "text-white" : (rowData.high < rowData.basePrice ? "text-red" : "text-green")) + " flex justify-content-center font-bold mb-1"}>{ rowData?.high ? rowData?.high?.toLocaleString('en-US') : '-'}</span>
                <span className={(rowData.low == rowData.basePrice || rowData.low == 0  ? "text-white" : (rowData.low < rowData.basePrice ? "text-red" : "text-green")) + " flex justify-content-center text-sm mb-1"}>{ rowData?.low ? rowData?.low?.toLocaleString('en-US') : '-'}</span>
            </div>
        );
    }

    function onChangeBoard(e) {
        let val = e.currentTarget.value;
        setCookie('bType', val == 2 ? 'G' : 'M');
        setMType(val);
    }

    async function updateMarketSummary() {
        let lang = i18n.language ?? 'en';
        await retrieveMarketSummary({type: mType, lang: lang, sort: sort}, authHeader())
        .then((response) => {
            let data = response.data.data;
            let totalValue = 0, totalVolume = 0;
            let totalMktCap = 0, totalFullMktCap = 0;
            let stockData = [];
            
            data.map((v, i) => { 
                totalValue += v.val_price
                totalVolume += v.vol_qty
                totalMktCap += v.mkt_cap
                totalFullMktCap += v.full_mkt_cap

                var diviSign =1
                var txtdiv = '';
                if (v.divi == 1) {
                    txtdiv = <img src="/img/d-sign.png" className="vertical-align-super" />;
                    diviSign = 1;
                }

                if (v.dx == 1) {
                    txtdiv = <img src="/img/xd-sign.png" className="vertical-align-super" />;
                    diviSign = 2;
                }

                stockData[i] = {
                    "icode": v.issue_code,
                    "stock": v.symbol,
                    "bid": v.bid_price,
                    "bidVol": v.bid_qty,
                    "change": v.chg,
                    "ask": v.ask_price,
                    "askVol": v.ask_qty,
                    "last": v.last_price,
                    "high": v.high_price,
                    "low": v.low_price,
                    "volume": v.vol_qty,
                    "value":  v.val_price,
                    "lp": v.lp,
                    "basePrice": v.base_price,
                    "lower": v.lower_price,
                    "higher": v.upper_price,
                    "diviSign": diviSign,
                    "txtdiv": txtdiv,
                    "type_of_dividend": v.type_of_dividend,
                    "dividend_per_share": v.dividend_per_share,
                    "ex_dividend_date": v.ex_dividend_date,
                    "record_date": v.record_date,
                    "payment_date": v.payment_date,
                    "link": v.link
                }
            });
            setIssues(stockData);
            setTrdSum({
                'totalValue': totalValue,
                'totalVolume': totalVolume,
                'totalMktCap': totalMktCap,
                'totalFullMktCap': totalFullMktCap,
            })
            setLoading(false)
        })
        .catch((error) => console.log(error))
    }

    useEffect(() => {
        setLoading(true);
        updateMarketSummary();
        const interval = setInterval(updateMarketSummary, 5000);
        if (STATE == 99 || (new Date().setHours(15,10,0)) < (new Date().getTime())) {
            clearInterval(interval)
        }
        return () => {
            clearInterval(interval)
        }
    }, [mType, sort, STATE]);

    return (
        <>
            <div className="col-12 text-white -mt-3 mb-3">
                <div className='grid'>
                    <div className="col-12 lg:col-4">
                        <div className="text-white shadow-3 px-3 pb-3 pt-4 border-round-lg bg-card">
                            <div className="grid md:font-bold">
                                <div className="col-12 py-1 flex justify-content-between">
                                    <div className="flex">Trading Volume</div>
                                    <div className="text-right">{trdSum?.totalVolume?.toLocaleString('en-US')}</div>
                                </div>
                                <div className="col-12 py-1 flex justify-content-between">
                                    <div className="flex">Trading Value</div>
                                    <div className="text-right">{trdSum?.totalValue?.toLocaleString('en-US')}</div>
                                </div>
                                <div className="col-12 py-1 flex justify-content-between">
                                    <div className="flex">Market Cap. (M) <span className="vertical-align-super mkCap text-xs text-yellow-500">&nbsp;(1)</span></div>
                                    <div className="text-right">{trdSum?.totalMktCap?.toLocaleString('en-US', { maximumFractionDigits: 0 })}</div>
                                </div>
                                <div className="col-12 py-1 flex justify-content-between">
                                    <div className="flex">Full Market Cap. (M)<span className="vertical-align-super fullMkCap text-xs text-yellow-500">&nbsp;(2)</span></div>
                                    <div className="text-right">{trdSum?.totalFullMktCap?.toLocaleString('en-US', { maximumFractionDigits: 0 })}</div>
                                </div>
                                <div className="col-12 text-yellow-500 text-xs">
                                    {t('Trading Volume Remark')}
                                </div>

                                <Tooltip target=".mkCap" position='right' event='both'>{t('(1) Market Cap. = listed shares * current price')}</Tooltip>
                                <Tooltip target=".fullMkCap" position='right' event='both'>{t('(2) Full Market Cap. = total issued shares * current price')}</Tooltip>
                            </div>
                        </div>
                    </div>
                    <IndexSummary STATE={STATE}/>
                    <DateTime />
                </div>
            </div>
            <div className='col-12'>
                <div className='flex align-items-center justify-content-between'>
                    <div className="flex gap-2">
                        <span className='flex xl:text-4xl lg:text-3xl md:text-2xl font-bold'>{t('Real Time Quotation')}</span>
                        
                    </div>
                    <div className='flex gap-1 align-items-center'>
                        <span className="sort-field hidden-print">
                            <Dropdown inputId="dd-city" value={sort} onChange={(e) => {setSort(e.value); setCookie('mksSort', e.value)}} options={sortFields} optionLabel="name" className="w-full md:w-14rem border-round-lg" placeholder="Select a sort field" />
                        </span>
                        <Button label={t("Main Board")} className={(mType == 1 ? 'b-btn-focus' : '') + " md:text-lg text-xs"} style={{borderRadius: '0.5rem'}} severity="info" value="1" rounded outlined raised onClick={onChangeBoard}/>
                        <Button label={t("Growth Board")} className={(mType == 2 ? 'b-btn-focus' : '') + " md:text-lg text-xs"} style={{borderRadius: '0.5rem'}} severity="info" value="2" rounded outlined raised onClick={onChangeBoard}/>
                    </div>
                </div>
            </div>
            <div className='col-12'>
                <div className="card p-4 pt-3 shadow-3 border-round-lg bg-card">
                    <DataTable value={issues} tableStyle={{ minWidth: '20rem' }} className="md:text-lg text-xs" tableClassName="bg-none" loading={loading}>
                        <Column field="stock" header={t('Stock Symbol')} body={stockBodyTemplate} headerClassName="pr-0" className="border-blue-700 text-white" bodyClassName="w-11rem" style={{background: 'none'}}></Column>
                        <Column field="bid" align="center" header={t('Bid')+' / '+t('Vol')} body={bidBodyTemplate} className="border-blue-700 text-white" bodyClassName="w-2" style={{background: 'none'}}></Column>
                        <Column field="ask" align="center" header={t('Ask')+' / '+t('Vol')} body={askBodyTemplate} className="border-blue-700 text-white" style={{background: 'none'}}></Column>
                        <Column field="last" align="center" header={t('Last')+' / '+t('Change')} body={lastBodyTemplate} className="border-blue-700 text-white w-2" style={{background: 'none'}}></Column>
                        <Column field="high" align="center" header={t('High')+' / '+t('Low')} body={highLowBodyTemplate} className="border-blue-700 text-white" style={{background: 'none'}}></Column>
                        <Column field="volume" align="center" header={t('Trading Vol')+' / '+t('Trading Val')} body={tradingBodyTemplate} className="border-blue-700 text-white w-2" style={{background: 'none'}}></Column>
                    </DataTable>
                </div>
            </div>
        </>
    )
}

function ChangeSign({change, vol_qty, base_price, last_price, lower_price, upper_price}) {
    var sq = false;
    if (vol_qty == 0 && base_price != last_price) {                        
        sq = true;
    }
    var tmpHtml = '';

    if (sq) {
        if (change > 0) {
            if (last_price == upper_price) {                                
                tmpHtml = <span><img className="change-arrow" src="/img/sq_upper_sign.png" /> &nbsp;</span>;
            } else {                                
                tmpHtml = <span><img className="change-arrow" src="/img/sq_up_sign.png" />  &nbsp;</span>;
            }                            
        } else if (change == 0) {
            tmpHtml = <span><img className="change-arrow" src="/img/unchange_sign.png" />  &nbsp;</span>;
        } else {
            if (last_price == lower_price) {
                tmpHtml = <span><img className="change-arrow" src="/img/sq_lower_sign.png" /> &nbsp;</span>;
            } else {
                tmpHtml = <span><img className="change-arrow" src="/img/sq_low_sign.png" />  &nbsp;</span> ;
            }
        }
    } else {
        if (change > 0) {
            if (last_price == upper_price) {                                
                tmpHtml = <span> <img className="change-arrow" src="/img/upper_sign.png" /> &nbsp;</span>;
            } else {           
                tmpHtml = <span><img className="change-arrow" src="/img/up_sign.png" /> &nbsp; </span>;
            }                            
        } else if (change == 0) {
            tmpHtml = <span><img className="change-arrow" src="/img/unchange_sign.png" />  &nbsp;</span>;
        } else {
            if (last_price == lower_price) {
                tmpHtml = <span><img className="change-arrow" src="/img/lower_sign.png" /> &nbsp;</span>;
            } else {
                tmpHtml = <span><img className="change-arrow" src="/img/low_sign.png" /> &nbsp;</span> ;
            }
        }
    }

    return (
        <>{tmpHtml}</>
    );
}

function SdDialog({ link, description }) {
  const { t } = useTranslation();
  const [sdVisible, setSdVisible] = useState(false);

  return (
    <>
      <span onClick={() => setSdVisible(true)}>
        <img src="/img/sd-sign.png" className="vertical-align-super"></img>
      </span>
      <Dialog
        header={t("SPECIAL DIVIDEND")}
        headerClassName="text-yellow-500 border-bottom-1 border-blue-700 bg-dialog -mb-4"
        contentClassName="bg-dialog"
        className="w-30rem text-white border-round-2xl"
        visible={sdVisible}
        onHide={() => setSdVisible(false)}
      >
        <div className="grid text-white pt-3 px-2 line-height-3">
          <span className="pb-2">{t(description)}</span>
          <a
            href="http://csx.com.kh/data/lstcom/listPosts.do?MNCD=60204"
            target="_blank"
            className="text-yellow"
          >
            {t("learn more from the CSX website")}
          </a>
        </div>
      </Dialog>
    </>
  );
}

